var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('Header', {
    attrs: {
      "meta": _vm.meta,
      "showMemberCenter": false,
      "pageTitle": _vm.getModuleConfig('page_title'),
      "pageImage": _vm.getModuleConfig('page_image')
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }